import { createContext, useContext } from 'react';

const Context = createContext();

export { Context, useContext };
